"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TourAlarmInfosBlock = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TourAlarmInfosBlock = function TourAlarmInfosBlock(_ref) {
  var activatedAlarms = _ref.activatedAlarms;

  if (activatedAlarms && activatedAlarms.length > 0) {
    var alarmsText = activatedAlarms.map(function (alarm) {
      return alarm.name;
    }).join(', ');
    return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Alarms, {
      className: "inline-block"
    }), alarmsText);
  }

  return null;
};

exports.TourAlarmInfosBlock = TourAlarmInfosBlock;
TourAlarmInfosBlock.propTypes = {
  activatedAlarms: _propTypes["default"].arrayOf({}).isRequired
};
TourAlarmInfosBlock.defaultProps = {};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.extended'])(TourAlarmInfosBlock);

exports["default"] = _default;